import { Root } from '@radix-ui/react-dialog';

export const ModalRoot = Root;
